module.exports = __webpack_public_path__ + "media/images/countryrect/ck-273d50a8e76f4fe76b75fee19264bff0.svg";